import React, { useState } from 'react';
import Modal from '../common/Modal';
import Icon from '../common/Icon';
import { beginGlobalExport } from './constants/globalSearch';

// TODO: css on this modal!

const GlobalExportModal = ({
  viewExportModal,
  setViewExportModal,
  authorizedContainers,
  value,
}) => {
  const [containerIds, setContainerIds] = useState([]);
  const closeModal = () => {
    setContainerIds([]);
    setViewExportModal(false);
  };

  const clearAll = () => setContainerIds([]);
  const selectAll = () =>
    setContainerIds(authorizedContainers.map((c) => c.id));

  const toggleClass = (id) =>
    containerIds.includes(id) ? 'toggle-on' : 'toggle-off';

  const toggleContainerId = (id) => {
    containerIds.includes(id)
      ? setContainerIds(containerIds.filter((cId) => cId != id))
      : setContainerIds(containerIds.concat(id));
  };

  const handleExportResult = (ids, value) => {
    if (ids.length && value.length) {
      beginGlobalExport(ids, value);
      closeModal();
    }
  };

  return (
    <Modal show={viewExportModal} onClose={closeModal} title='global-exports'>
      <header>
        <h3>Export Global Search Results</h3>
      </header>

      <div className='row'>
        <div className='right'>
          <button className='blue' onClick={() => selectAll()}>
            Select All
          </button>
          <button className='blue' onClick={() => clearAll()}>
            Clear All
          </button>
        </div>
      </div>

      <div className='global-exports-containers'>
        <table>
          <thead>
            <tr>
              <th>Containers</th>
              <th>Selected</th>
            </tr>
          </thead>
          <tbody>
            {authorizedContainers.map((container) => (
              <tr key={`ex-${container.id}`}>
                <td>{container.name} </td>
                <td>
                  <Icon
                    icon={toggleClass(container.id)}
                    onClick={() => toggleContainerId(container.id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <hr />

      <div className='row'>
        <div className='right'>
          <button onClick={() => handleExportResult(containerIds, value)}>
            Export Selected
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GlobalExportModal;
